import { FC, PropsWithChildren } from 'react'
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js'
import { reactPlugin } from './monitoring' // Adjust the import path as needed
import { MessagePopup } from '@skytech/ui'

export const AppWithMonitoring: FC<PropsWithChildren> = ({ children }) =>
  reactPlugin ? (
    <AppInsightsErrorBoundary appInsights={reactPlugin} onError={FallbackUIComponent}>
      <>{children}</>
    </AppInsightsErrorBoundary>
  ) : (
    <>{children}</>
  )

// TODO: Implement a better FallbackUIComponent also add Translation component to the UI lib
const FallbackUIComponent = (ctx: { error: Error }) => (
  <MessagePopup
    isOpen
    title={'Oops! We encountered an issue...'}
    message={
      <>
        Something unexpected has happened! The error has been reported. We are already working on
        fixing it! Error: <br />
        {ctx?.error?.message}
      </>
    }
  />
)

export const TestErrorPage = () => {
  throw Error('This is a test error page for Monitoring. Date: ' + new Date().toISOString())
}
